(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      window.matchMedia('(max-width: 1023px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.createObserver();
      this.initAnnouncement();
      this.initMobileNav();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      // Glass effect at 100px
      if (scrollTop > 100) {
        this.header.classList.add('is-scrolled');
      } else {
        this.header.classList.remove('is-scrolled');
      }

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }

    // ── Announcement bar rotation ───────────────────────────
    initAnnouncement() {
      const el = this.querySelector('.announcement-text');
      if (!el) return;

      const dataEl = document.querySelector(`[id^="announcementMessages-"]`);
      if (!dataEl) return;

      let messages;
      try {
        messages = JSON.parse(dataEl.textContent);
      } catch (e) {
        return;
      }
      if (!messages || messages.length < 2) return;

      let current = 0;
      let paused = false;

      el.addEventListener('focusin', () => {
        paused = true;
      });
      el.addEventListener('focusout', () => {
        paused = false;
      });

      setInterval(() => {
        if (paused) return;
        el.style.opacity = '0';
        setTimeout(() => {
          if (paused) {
            el.style.opacity = '1';
            return;
          }
          current = (current + 1) % messages.length;
          const msg = messages[current];
          el.textContent = msg.text;
          if (el.tagName === 'A') {
            el.href = msg.link || '#';
          }
          el.style.opacity = '1';
        }, 400);
      }, 4000);
    }

    // ── Mobile nav overlay ──────────────────────────────────
    initMobileNav() {
      const hamburgerBtn = this.querySelector('.hamburger-btn');
      const hamburgerIcon = this.querySelector('.hamburger-icon');
      const overlay = this.parentElement && this.parentElement.querySelector('.mobile-nav-overlay');
      if (!hamburgerBtn || !overlay) return;

      let isOpen = false;

      const openNav = () => {
        isOpen = true;
        overlay.classList.add('is-open');
        hamburgerIcon && hamburgerIcon.classList.replace('ph-list', 'ph-x');
        hamburgerBtn.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
      };

      const closeNav = () => {
        isOpen = false;
        overlay.classList.remove('is-open');
        hamburgerIcon && hamburgerIcon.classList.replace('ph-x', 'ph-list');
        hamburgerBtn.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      };

      hamburgerBtn.addEventListener('click', () => (isOpen ? closeNav() : openNav()));

      const closeBtn = overlay.querySelector('.mobile-nav-close');
      if (closeBtn) closeBtn.addEventListener('click', closeNav);

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && isOpen) closeNav();
      });

      // Accordion sub-menus
      overlay.querySelectorAll('[data-mobile-accordion]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const list = btn.nextElementSibling;
          const caret = btn.querySelector('.mobile-accordion-caret');
          const expanded = btn.getAttribute('aria-expanded') === 'true';

          // Close all others first
          overlay.querySelectorAll('[data-mobile-accordion]').forEach((other) => {
            if (other === btn) return;
            other.setAttribute('aria-expanded', 'false');
            const otherList = other.nextElementSibling;
            const otherCaret = other.querySelector('.mobile-accordion-caret');
            if (otherList) otherList.classList.remove('is-open');
            if (otherCaret) otherCaret.classList.remove('is-open');
          });

          btn.setAttribute('aria-expanded', String(!expanded));
          if (list) list.classList.toggle('is-open', !expanded);
          if (caret) caret.classList.toggle('is-open', !expanded);
        });
      });
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
